import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import actions from "actions";
import constants from "constants";
import LandingView from "components/Landing/Landing";
import _ from "lodash";

const {
  loadUpcomingWebinarsSaga,
  loadCurrentWebinarsSaga,
  loadPreviousWebinarsSaga,
  loadSubscriptionsSaga,
  loadLandingWebinarsSaga,
  cleanWebinars,
  loadLandingDataUserSaga,
  login,
} = actions;

const {
  UPCOMING_WEBINARS,
  CURRENT_WEBINARS,
  PREVIOUS_WEBINARS,
  LANDING_WEBINARS,
} = constants;

class Landing extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      isMobile: !window.matchMedia("(min-width: 600px)").matches,
      inputData: {
        email: "",
        password: "",
      },
      isLoading: false,
      page: {
        upcoming: 1,
        current: 1,
        previous: 1,
        landing: 1,
      },
    };
  }
  componentDidMount() {
    const handler = (e) =>
      this.setState({ ...this.state, isMobile: !e.matches });
    window.matchMedia("(min-width: 600px)").addEventListener("change", handler);
  }

  onChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      ...prev,
      inputData: { ...prev.inputData, [name]: value },
    }));
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState((prev) => ({ ...prev, isLoading: true }));
    try {
      await this.props.login(
        this.state.inputData.email.toLocaleLowerCase(),
        this.state.inputData.password
      );
    } catch (err) {
      console.log(err);
    }
    this.setState((prev) => ({ ...prev, isLoading: false }));
  };

  componentWillMount() {
    this.props.loadUpcomingWebinars(this.state.page.upcoming);
    this.props.loadLandingData(this.state.page.landing);
    this.props.loadLandingWebinarsSaga(this.state.page.landing);
  }

  // nextPage = (webinarType) => {
  //   switch (webinarType) {
  //     case UPCOMING_WEBINARS:
  //       this.setState({ page: { ...this.state.page, upcoming: this.state.page.upcoming + 1 } },
  //         () => this.props.loadUpcomingWebinars(this.state.page.upcoming))
  //       break;
  //   }
  // }

  nextPage = (webinarType) => {
    switch (webinarType) {
      case LANDING_WEBINARS:
        this.setState(
          {
            page: { ...this.state.page, landing: this.state.page.landing + 1 },
          },
          () => this.props.loadLandingWebinarsSaga(this.state.page.landing)
        );
        break;
    }
  };

  componentWillUnmount() {
    this.props.cleanWebinars();
  }

  render() {
    return (
      <LandingView
        isMobile={this.state.isMobile}
        userId={this.props.user.id}
        inputData={this.state.inputData}
        handleChange={this.onChange}
        handleSubmitLogin={this.handleSubmit}
        webinars={this.props.landing.values}
        nextPage={() => this.nextPage(LANDING_WEBINARS)}
        page={this.state.page.landing}
        count={this.props.landing.count}
        landingText={this.props.landingData}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  upcoming: state.webinars[UPCOMING_WEBINARS],
  current: state.webinars[CURRENT_WEBINARS],
  previous: state.webinars[PREVIOUS_WEBINARS],
  landing: state.webinars[LANDING_WEBINARS],
  user: state.users.user,
  landingData: state.landingData.body,
});

const mapDispatchToProps = (dispatch) => ({
  loadCurrentWebinars: (page) => dispatch(loadCurrentWebinarsSaga(page)),
  loadUpcomingWebinars: (page) => dispatch(loadUpcomingWebinarsSaga(page)),
  loadLandingWebinarsSaga: (page) => dispatch(loadLandingWebinarsSaga(page)),
  loadPreviousWebinars: (page) => dispatch(loadPreviousWebinarsSaga(page)),
  loadSubscriptions: () => dispatch(loadSubscriptionsSaga()),
  loadLandingData: () => dispatch(loadLandingDataUserSaga()),
  cleanWebinars: () => dispatch(cleanWebinars()),
  login: (email, password) => dispatch(login(email, password)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Landing);



// WEBPACK FOOTER //
// ./src/containers/Landing/Landing.jsx